import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TheGlobalProforceNexus from "./sections/TheGlobalProforceNexus";
import TheEtlobEdge from "./sections/TheEtlobEdge";
import EnterpriseAvSolutions from "./sections/EnterpriseAvSolutions";
import OurExecutionModel from "./sections/OurExecutionModel";
import IntegratedCyberSecurity from "./sections/IntegratedCyberSecurity";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <TheGlobalProforceNexus />
      <TheEtlobEdge />
      <EnterpriseAvSolutions />
      <OurExecutionModel />
      <IntegratedCyberSecurity />
      <Footer />
    </div>;
}